import { makeStyles, MenuItem, OutlinedInput } from "@material-ui/core";
import { Form, Modal, Row, Col, Button, Divider, Select } from "antd";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { v4 } from "uuid";
import { useBilling } from "../../KOTbillingProvider";
import { useCountry } from "../../../../provider/courtryProvider";

const UNIT = [
  "g",
  "kg",
  "mg",
  "ml",
  "L",
  "cup",
  "count",
  "box",
  "pkt",
  "glass",
  "cm",
  "m",
  "km",
  "min",
  "hour",
  "days",
  "inch",
  "Ton",
];

const useStyles = makeStyles((theme) => ({
  dividerStyle: {
    marginTop: 14,
    marginBottom: 14,
    border: "0.5px solid #909090",
  },
  modalStyle: {
    "& .ant-modal-content": {
      borderRadius: "2rem",
    },
  },
  ButtonStyle: {
    backgroundColor: "#EF4667",
    color: "#fff",
    border: 0,
    borderRadius: "4px",
    paddingLeft: "34px",
    paddingRight: "34px",
    "&:hover": {
      backgroundColor: "#EF4667",
      color: "#fff",
    },
  },
  selectStyle: {
    border: "1px solid rgba(0, 0, 0, 0.23)",
    borderRadius: "4px",
    outline: "none",
    "& legend": {
      display: "none",
    },
    "& .MuiInput-underline:hover:not(.Mui-disabled):before": {
      border: "0 !important",
    },
    "& .MuiInput-underline": {
      "&:before": {
        border: "0 !important",
      },
    },
  },
  inputStyle: {
    "& label": {
      display: "none",
    },
  },
  formItem: {
    marginBottom: "0",
  },
}));
const AddItemProduct = ({ open, setOpen }) => {
  const taxList = useSelector((state) => state.taxList.taxList);
  const { addProductToBilling } = useBilling();
  const [form] = Form.useForm();
  const classes = useStyles();
  const shopId = useSelector((state) => state.shopDetails.shopId);
  const country = useCountry();
  const onFinish = (values) => {
    console.log("Success:", values);
    const product = {
      productId: v4(),
      ...values,
      ...(values.measurmentValue && {
        unitOfMeasurment: values.measurmentValue + " " + values.measurmentUnit,
      }),
      measurmentValue: undefined,
      measurmentUnit: undefined,
      isExist: false,
      addedDate: new Date().toISOString().substring(0, 10),
      shopId: shopId,
      versionId: "1",
      inventoryQty: 0,
      latest: "true",
      category: "Others",
      status: "new",
      productType: "product",
    };
    addProductToBilling(product);
    setOpen(false);
    form.resetFields();
  };

  const handleClose = () => {
    setOpen(false);
    form.resetFields();
  };
  return (
    <>
      <Modal
        className={classes.modalStyle}
        open={open}
        centered
        onCancel={() => setOpen(false)}
        width="700px"
        footer={null}
        getContainer={false}
      >
        <h3
          style={{
            color: "#EF4667",
          }}
        >
          Add Item
        </h3>
        <Divider className={classes.dividerStyle} />
        <Form
          wrapperCol={{ span: 24 }}
          labelCol={{ span: 24 }}
          onFinish={onFinish}
          form={form}
        >
          <Row gutter={16}>
            <Col span={8}>
              <Form.Item
                label="Product Name"
                name={"productName"}
                className={classes.formItem}
                rules={[
                  {
                    required: true,
                    message: "Please enter product name",
                  },
                ]}
              >
                <OutlinedInput />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item
                label="Selling Price"
                name={"productPrice"}
                className={classes.formItem}
                rules={[
                  {
                    required: true,
                    message: "Please enter Selling price",
                  },
                ]}
              >
                <OutlinedInput type="number" />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item
                label="Product MRP"
                name={"productMRP"}
                className={classes.formItem}
              >
                <OutlinedInput type="number" />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item
                label="Item Barcode"
                name={"productHsnCode"}
                className={classes.formItem}
              >
                <OutlinedInput />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item
                label={`Purchase Price (${country.CurrencySymbol})`}
                name="purchasePrice"
                className={classes.formItem}
                rules={[
                  {
                    required: true,
                    message: "Please enter Purchase Price",
                  },
                ]}
              >
                <OutlinedInput type="number" />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item
                label="Quantity"
                name={"count"}
                className={classes.formItem}
                rules={[
                  {
                    required: true,
                    message: "Please enter Quantity",
                  },
                ]}
              >
                <OutlinedInput type="number" />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Row>
                <Col span={18}>
                  <Form.Item
                    className={classes.formItem}
                    label="Unit(s)"
                    name="measurmentValue"
                  >
                    <OutlinedInput />
                  </Form.Item>
                </Col>
                <Col span={6}>
                  <Form.Item
                    style={{ marginTop: "43px" }}
                    className={classes.formItem}
                    name="measurmentUnit"
                  >
                    <Select
                      style={{
                        width: "100%",
                      }}
                      className={classes.selectStyle}
                    >
                      {UNIT?.map((item, index) => (
                        <Select.Option key={index} value={item}>
                          {item}
                        </Select.Option>
                      ))}
                    </Select>
                  </Form.Item>
                </Col>
              </Row>
            </Col>
            <Col span={8}>
              <Form.Item className={classes.formItem} label="Tax" name="taxId">
                <Select
                  displayEmpty
                  inputProps={{ "aria-label": "Without label" }}
                  style={{
                    width: "100%",
                  }}
                  className={classes.selectStyle}
                >
                  {taxList?.map((tax) => (
                    <MenuItem key={tax.taxId} value={tax.taxId}>
                      {tax.taxName}
                    </MenuItem>
                  ))}
                </Select>
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item
                className={classes.formItem}
                label="Inclusive/Exclusive"
                name={"taxIncExc"}
              >
                <Select
                  displayEmpty
                  style={{
                    width: "100%",
                  }}
                  className={classes.selectStyle}
                >
                  <MenuItem value={"inclusive"}>Inclusive</MenuItem>
                  <MenuItem value={"exclusive"}>Exclusive</MenuItem>
                </Select>
              </Form.Item>
            </Col>
          </Row>
          <Divider className={classes.dividerStyle} />
          <div
            style={{
              textAlign: "right",
            }}
          >
            <Button
              style={{
                color: "#EF4667",
                fontWeight: "700",
                background: "##FDE8EC",
                border: 0,
                borderRadius: "4px",
              }}
              size="large"
              variant="outlined"
              onClick={handleClose}
            >
              Cancel
            </Button>
            <Button
              style={{
                color: "#fff",
                fontWeight: "700",
                background: "#EF4667",
                marginLeft: "16px",
                border: 0,
                borderRadius: "4px",
              }}
              htmlType="submit"
              size="large"
            >
              Add Item
            </Button>
          </div>
        </Form>
      </Modal>
    </>
  );
};

export default AddItemProduct;
